@if (loading) {
  <div class="spinner-wrapper">
    <app-spinner forceTo='component-sized'></app-spinner>
  </div>
}

<cdk-virtual-scroll-viewport #scroll itemSize="15" class="scroll" [ngClass]="{'grupo': modeGroup}">
  @if (finalPlays?.length > 0) {
    @for (play of finalPlays; track play; let i = $index; let last = $last) {
      <div class="plays-row">
        @if (modeGroup) {
          <app-participation-product [play]="play" [device]="device" [abono]="abonos" (dropAbono)="dropAbonoList($event)"
          [grupo]="grupo" [ngClass]="{'mb5': last}"></app-participation-product>
        } @else {
          <app-participation-product [play]="play" [device]="device" [abono]="abonos" (dropAbono)="dropAbonoList($event)"
          [ngClass]="{'mb5': last}"></app-participation-product>
        }
      </div>
    }
  }
  @if (finalPlays?.length == 0 && loading == false) {
    <div class="no-plays">
      <h3 class="no-plays-text">
        Aquí parece que todavía no hay mucho que ver
      </h3>
      <img class="image" src="/assets/images/icons/plays-list/no-plays.svg" />
    </div>
  }
  @if (spinnerBottomLoadVisibility) {
    <div style="display: flex; justify-content: center; margin: 25px;">
      <mat-progress-spinner class="spinner" [mode]="'indeterminate'"
      [diameter]="35"> </mat-progress-spinner>
    </div>
  }
</cdk-virtual-scroll-viewport>